<div class="std-empty-state">
  <svg class="w-[3.125rem] h-[3.125rem] opacity0p64 entered-row-container flex00auto">
    <use [attr.xlink:href]="iconName + '#img'" [attr.href]="iconName + '#img'"></use>
  </svg>
  <span class="flex flex-col items-center content-center opacity0p64 gap-[0.5rem]">
    @if (heading) {
      <span class="{{titleClass}} bold600">{{ heading }}</span>
    }
    @if (description) {
      <span class="font-3">{{ description }}</span>
    }
  </span>
  @if (!useTwoButtons) {
    <div>
      @if (isAdmin && !buttonIconName) {
        <app-button
          data-qa="empty-state-button"
          [size]="'small'"
          [type]="'accent'"
          (buttonClick)="buttonClick.emit()"
        >
          {{ buttonText }}
        </app-button>
      }
      @if (isAdmin && buttonIconName) {
        <app-button
          data-qa="empty-state-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="buttonIconName"
          (buttonClick)="buttonClick.emit()"
        >
          {{ buttonText }}
        </app-button>
      }
    </div>
  }
  @if (useTwoButtons) {
    <div class="flex flex-row items-center justify-start gap-[0.375rem]">
      @if (isAdmin && !buttonIconName) {
        <app-button
          data-qa="empty-state-button"
          [size]="'small'"
          [type]="'accent'"
          (buttonClick)="buttonClick.emit()"
        >
          {{ buttonText }}
        </app-button>
      }
      @if (isAdmin && buttonIconName) {
        <app-button
          data-qa="empty-state-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="buttonIconName"
          (buttonClick)="buttonClick.emit()"
        >
          {{ buttonText }}
        </app-button>
      }
      @if (isAdmin && !buttonIconName) {
        <app-button
          data-qa="empty-state-button"
          [size]="'small'"
          [type]="'accent'"
          (buttonClick)="secondButtonClick.emit()"
        >
          {{ secondButtonText }}
        </app-button>
      }
      @if (isAdmin && buttonIconName) {
        <app-button
          data-qa="empty-state-button"
          [size]="'small'"
          [type]="'accent'"
          [iconName]="secondButtonIconName"
          (buttonClick)="secondButtonClick.emit()"
        >
          {{ secondButtonText }}
        </app-button>
      }
    </div>
  }
</div>
